import Breadcrumb from "../components/Breadcrumb";
import Staff from "../components/Staff";

const StaffPage = () => {
  return (
    <>
      {/* Breadcrumb */}
      <Breadcrumb title="Staff" />

      <Staff />
    </>
  );
};

export default StaffPage;
